import { render, staticRenderFns } from "./DialogUndoButton.vue?vue&type=template&id=18656a50"
import script from "./DialogUndoButton.vue?vue&type=script&lang=js"
export * from "./DialogUndoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports